var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiudaName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 53,
    viewBox: "0 0 154 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10750_4018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.38599H7.83146V33.3777L20.0926 21.046H29.7456L17.2397 33.4371L29.9274 51.9014H21.124L12.3206 38.2963L7.82796 42.7288V51.9014H0V9.38599Z",
    fill: "#456A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2976 21.0496H42.1291V51.905H34.2976V21.0496Z",
    fill: "#456A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2167 51.905H72.9655L71.6299 48.6865C69.3854 51.4187 65.9242 53 60.7638 53C52.5687 53 49.2893 49.2952 49.2893 40.0631V21.0496H57.1208V38.4224C57.1208 43.9498 58.5787 46.7449 63.4349 46.7449C68.2911 46.7449 71.3887 43.6454 71.3887 36.3583V21.0531H79.2202V51.9085L79.2167 51.905Z",
    fill: "#456A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.235 48.3821C107.99 51.1773 104.466 52.9999 99.3685 52.9999C89.7784 52.9999 85.4082 46.8638 85.4082 36.4772C85.4082 26.0906 89.9602 19.9545 99.7356 19.9545C104.351 19.9545 107.567 21.4133 109.752 23.7187V9.38599H117.584V51.9049H111.815L110.238 48.3821H110.235ZM101.735 47.1682C106.773 47.1682 109.99 44.3135 109.99 36.4772C109.99 28.6409 106.773 25.7862 101.735 25.7862C96.2114 25.7862 93.3585 29.1866 93.3585 36.4772C93.3585 43.7678 96.2114 47.1682 101.735 47.1682Z",
    fill: "#456A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.977 25.482C135.362 25.482 133.24 26.9408 133.117 30.8275H125.468C125.226 23.5369 130.142 19.9546 140.096 19.9546C150.658 19.9546 153.996 23.8413 153.996 32.7725V51.905H148.35L146.955 48.6865C144.892 51.2368 141.672 53 136.634 53C130.016 53 124.373 49.9005 124.373 43.0367C124.373 36.5997 129.352 33.3778 138.82 33.3183C141.186 33.2588 143.676 33.2588 146.347 33.1364V32.1638C146.347 27.2452 144.952 25.482 139.973 25.482H139.977ZM138.278 47.714C144.288 47.714 146.532 43.3411 146.291 38.118C143.983 38.1775 142.043 38.118 140.099 38.1775C134.816 38.2999 132.331 39.6958 132.331 43.0367C132.331 46.0138 134.393 47.714 138.281 47.714H138.278Z",
    fill: "#456A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.238 9.40698H26.3262V15.9944H34.238V9.40698Z",
    fill: "#A9CF38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0479 9.40698H42.136V15.9944H50.0479V9.40698Z",
    fill: "#A9CF38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1499 0H34.238V6.58739H42.1499V0Z",
    fill: "#A9CF38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10750_4018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 53,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiudaName);
export default __webpack_public_path__ + "static/media/kiuda-name.d54eea1a725b279420ce6e7f349aa61b.svg";
export { ForwardRef as ReactComponent };